import { render, staticRenderFns } from "./saldokredit.vue?vue&type=template&id=290b9372&scoped=true&"
import script from "./saldokredit.vue?vue&type=script&lang=js&"
export * from "./saldokredit.vue?vue&type=script&lang=js&"
import style0 from "./saldokredit.vue?vue&type=style&index=0&id=290b9372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290b9372",
  null
  
)

export default component.exports